import React,{useState,useEffect} from 'react'
import { useDispatch,useSelector } from 'react-redux'
import { getTrending } from 'redux/actions/forum'
import { CircularProgress } from '@material-ui/core'

export default function Search(props) {
    const dispatch = useDispatch()
    const persist = useSelector(state => state.persist)
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const {searchmodal,setsearchmodal}=props
    const {trending,beranda}=reducer

    useEffect(() => {
        dispatch(getTrending(persist.forum_id,5))
    }, [persist.forum_id])
    const convertHash=(tag)=>{
        let conv=tag.replace('#','%23')
        return conv
    }
    return (
            
        
        <div className='fix-menu-search'>
            {/* <div className='search-wrapper'>
                <input onClick={()=>setsearchmodal(!searchmodal)} className='search-field' readOnly placeholder="Cari diskusi"/>
                
            </div>
            
            <br/> */}
            {general.isLoadingFilter?
                <div style={{textAlign:'center'}}>
                    <CircularProgress style={{color:'#ff4e4e'}}  size={35} />
                </div>
            :
            <div>
                <h5 className='font-nunito margin-0 font-bold'>Trending di  {persist.forum_name} </h5>
                {trending.map((data,i)=>(
                <a key={i} href={`/search?q=${convertHash(data.tag)}`}><p  className='hashtag-item-right font-nunito'>{data.tag}</p></a>

                ))}
            </div>
            }
            {/* <br/>
            <div>
                <h5 className='font-nunito margin-0 font-bold'>Trending di QuBisa</h5>
                <p className='hashtag-item-right font-nunito'>#BSC</p>
                <p className='hashtag-item-right font-nunito'>#StrategyManagement</p>
                <p className='hashtag-item-right font-nunito'>#Pendidikan</p>
            </div> */}
        </div>
    )
}
